<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="10">
        <CardSplit
          version="v1"
          :img="{
            src: imgSrc,
          }"
          max-width="1200px"
          :error-message="errorMessage"
          :error-state="hasError"
        >
          <template #header>
            <v-row justify="center">
              <v-col cols="12" md="8" class="d-flex flex-column align-center pt-16">
                <Logo version="v2" class="mb-10" />
                <h1 class="text-h1 text-center font-weight-regular mb-4">
                  Bienvenidos
                </h1>
              </v-col>
            </v-row>
          </template>

          <template #footer>
            <p class="text-body-2 text-center terms">
              Revisa
              <a
                class="black--text"
                target="_blank"
                :href="getAssetsURL + 'policies/privacy-policy-yourney.pdf'"
              >
                aquí
              </a>
              la política de privacidad, datos personales y condiciones de uso.
            </p>
          </template>

          <v-row class="mb-10">
            <v-col cols="12" class="d-flex flex-column">
              <v-form @submit.prevent="onSubmit">
                <v-text-field
                  v-model="form.email"
                  class="rounded-md mb-4"
                  light
                  outlined
                  dense
                  label="Ingresa tu email"
                  type="email"
                  data-test="input-email"
                  data-type="string"
                  :rules="rules.email"
                />
                <v-text-field
                  v-model="form.password"
                  class="rounded-md mb-4"
                  light
                  outlined
                  dense
                  label="Ingresa tu contraseña"
                  :type="showPass ? 'text' : 'password'"
                  data-test="input-password"
                  data-type="string"
                  :append-icon="passwordIcon"
                  :rules="rules.password"
                  @click:append="showPass = !showPass"
                />
                <v-btn
                  class="rounded-md mb-2"
                  type="submit"
                  block
                  data-test="button-submit"
                  :loading="isLoading"
                >
                  Ingresar
                </v-btn>
                <div class="form__recover-link">
                  <router-link class="text-body-2" :to="{ name: 'Recover' }">
                    Recuperar contraseña
                  </router-link>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </CardSplit>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import router from "@/router";
import store from "@/store";
import { createClient } from "@/vue-apollo";
import { isRequired, isEmail } from "../lib/validators";
import CardSplit from "@/components/Base/CardSplit";
import Logo from "@/components/Base/Logo";

export default defineComponent({
  name: "LoginPage",

  components: {
    CardSplit,
    Logo,
  },

  metaInfo() {
    return {
      title: "Inicia sesión",
    };
  },

  setup() {
    // CardSplit
    const hasError = ref(false);
    const errorMessage = ref(
      "Credenciales incorrectas, ingresa nuevamente tu correo o contraseña"
    );
    const imgSrc =
      process.env.VUE_APP_ASSETS_BASE_PATH + "yourney/assets/login-split.png";

    // Form
    const isLoading = ref(false);
    const form = reactive({
      email: "",
      password: "",
    });
    const formattedEmail = computed(() => form.email.toLowerCase().trim());
    const rules = {
      email: [isRequired, isEmail()],
      password: [isRequired],
    };
    const showPass = ref(false);
    const passwordIcon = computed(() =>
      showPass.value ? "mdi-eye-off-outline" : "mdi-eye-outline"
    );
    const onSubmit = async (evt) => {
      try {
        isLoading.value = true;

        await store.dispatch("users/signin", {
          email: formattedEmail.value,
          password: form.password,
          apolloClient: createClient(),
        });

        router.push({ name: "Home" }).catch(() => {
          console.info("Navigation to redirection function.");
        });
      } catch (error) {
        console.error(error);
        hasError.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    return {
      errorMessage,
      form,
      hasError,
      imgSrc,
      isLoading,
      onSubmit,
      passwordIcon,
      rules,
      showPass,
    };
  },
});
</script>

<style lang="scss" scoped>
.form {
  &__recover-link {
    text-align: center;
    width: 100%;
    & a {
      text-decoration: none;
      padding-bottom: 2px;
      color: $cerulean-blue-600;
      &:hover {
        border-bottom: 1px solid $cerulean-blue-600 !important;
        cursor: pointer;
      }
    }
  }
}
.error-span {
  background: #f3c3c3;
  border-radius: 4px;
  height: 30px !important;
  width: 295px !important;
  color: #000000;
}

.terms {
  width: 80%;
  margin: 0 auto;
  color: $resilient-black-600;

  a {
    color: $resilient-black-600;
  }
}
</style>
